import { Image } from 'react-bootstrap'

export default () => (
    <Image id="weather-logo" alt="weather-logo" fluid className="w-50 mx-auto mt-4 py-2 mb-4" src="/assets/weather.png" />
)